__turbopack_context__.v({
  "hidden": "ArticleSectionRelatedTeasersClamp-module-scss-module__4Cr1Ba__hidden",
  "showMoreButton": "ArticleSectionRelatedTeasersClamp-module-scss-module__4Cr1Ba__showMoreButton",
  "wrapper": "ArticleSectionRelatedTeasersClamp-module-scss-module__4Cr1Ba__wrapper",
});
